export function localDateKey(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function currentAudioTimeOfDay(date = new Date()) {
  const hour = date.getHours();
  if (hour >= 5 && hour <= 11) return "MORNING";
  if (hour >= 12 && hour <= 16) return "AFTERNOON";
  if (hour >= 17 && hour <= 22) return "EVENING";
  return "NIGHT";
}

export function stringValue(value) {
  return typeof value === "string" ? value.trim() : "";
}

export function shortClientFingerprint(value) {
  let hash = 2166136261;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0).toString(36);
}

export function decodeMp3(audioContent) {
  const binary = atob(audioContent);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }
  return new Blob([bytes], { type: "audio/mpeg" });
}

export function finiteDuration(player) {
  return Number.isFinite(player.duration) && player.duration > 0 ? player.duration : 0;
}

export function setMediaPlaybackRatePreservingPosition(player, rate) {
  const position = Number(player.currentTime);
  player.playbackRate = rate;
  const positionAfterRateChange = Number(player.currentTime);
  if (
    Number.isFinite(position) &&
    position >= 0 &&
    Number.isFinite(positionAfterRateChange) &&
    positionAfterRateChange < position - 0.05
  ) {
    try {
      player.currentTime = position;
    } catch {
      /* Keep the applied rate when a non-seekable media source rejects restoration. */
    }
  }
  return player.playbackRate;
}

export function seekMediaPlaybackTo(player, seconds) {
  const duration = finiteDuration(player);
  if (duration <= 0 || !Number.isFinite(seconds)) return false;
  const rate = player.playbackRate;
  player.currentTime = Math.min(duration, Math.max(0, seconds));
  if (Number.isFinite(rate) && rate > 0 && player.playbackRate !== rate) {
    setMediaPlaybackRatePreservingPosition(player, rate);
  }
  return true;
}

export function bufferedFraction(player, duration = finiteDuration(player)) {
  if (duration <= 0 || player.buffered.length === 0) return 0;
  try {
    return Math.min(1, Math.max(0, player.buffered.end(player.buffered.length - 1) / duration));
  } catch {
    return 0;
  }
}
